import { render, staticRenderFns } from "./InfoSecondary.vue?vue&type=template&id=f8305fd4&scoped=true&"
import script from "./InfoSecondary.vue?vue&type=script&lang=js&"
export * from "./InfoSecondary.vue?vue&type=script&lang=js&"
import style0 from "./InfoSecondary.vue?vue&type=style&index=0&id=f8305fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8305fd4",
  null
  
)

export default component.exports